var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import equal from 'fast-deep-equal';
import { fieldValueIsSame, localeIsSame, } from '../../utils/formik';
import TextField from './TextField';
import { Autocomplete } from '@mui/material';
var AutocompleteSelectField = function (_a) {
    var items = _a.items, onChange = _a.onChange, textFieldProps = __rest(_a, ["items", "onChange"]);
    var _b = React.useState(items.find(function (item) { return item.value === textFieldProps.value; }) || null), value = _b[0], setValue = _b[1];
    var handleAutocompleteChange = React.useCallback(function (event, newValue) {
        setValue(newValue);
        if (onChange && newValue) {
            onChange(event, newValue);
        }
    }, [onChange]);
    return (React.createElement(Autocomplete, { disablePortal: true, autoHighlight: true, value: value, onChange: handleAutocompleteChange, options: items, getOptionLabel: function (item) { return item.text; }, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, textFieldProps)); } }));
};
export default AutocompleteSelectField;
var FormikAutocompleteSelectFieldUnmemoized = function (_a) {
    var _b = _a.formik, errors = _b.errors, handleBlur = _b.handleBlur, values = _b.values, setFieldValue = _b.setFieldValue, items = _a.items, selectFieldprops = __rest(_a, ["formik", "items"]);
    var nameAsKey = selectFieldprops.name;
    var onChange = selectFieldprops.onChange;
    var handleChange = React.useCallback(function (event, item) {
        setFieldValue(nameAsKey, item.value);
        onChange && onChange(event, item);
    }, [onChange, nameAsKey, setFieldValue]);
    return (React.createElement(AutocompleteSelectField, __assign({ items: items, onBlur: handleBlur, onChange: handleChange, value: values[nameAsKey], error: Boolean(errors[nameAsKey]), helperText: errors[nameAsKey] }, selectFieldprops)));
};
var itemsAreSame = function (prevProps, nextProps) { return equal(prevProps.items, nextProps.items); };
export var FormikAutocompleteSelectField = React.memo(FormikAutocompleteSelectFieldUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) &&
        fieldValueIsSame(prevProps, nextProps) &&
        itemsAreSame(prevProps, nextProps);
});
